(function() { window.GUID_82da8415_2045_40b8_b7a9_1db23c1166bf = { getGuid: function() { return "82da8415-2045-40b8-b7a9-1db23c1166bf"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class Purchase extends Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return this.$control;
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
                this.$control = $('#' + params[0]); //contient le Id
            }
            OnDispose() {
                this.$Control.off('click.' + this.UniqueNamespace, '.purchase-consumable');
                this.$Control.off('click.' + this.UniqueNamespace, '.purchase-subscription-monthly');
                this.$Control.off('click.' + this.UniqueNamespace, '.purchase-subscription-yearly');
                this.$Control.remove();
            }
            OnBindEvents() {
                let me = this;
                me.$Control.offon('click.' + this.UniqueNamespace, '.purchase-consumable', function (e) {
                    var purchase = JSON.stringify({ item: "compusport.notification", event: CS.CommonData.Current.Navigation.EventId, });
                    CS.NativeApp.NA_PurchaseConsumable(purchase);
                });
                me.$Control.offon('click.' + this.UniqueNamespace, '.purchase-subscription-monthly', function (e) {
                    CS.NativeApp.NA_PurchaseSubscription("compusport.subscription.month.10");
                });
                me.$Control.offon('click.' + this.UniqueNamespace, '.purchase-subscription-yearly', function (e) {
                    CS.NativeApp.NA_PurchaseSubscription("compusport.subscription.yearly.10");
                });
            }
        }
        Controls.Purchase = Purchase;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=purchase.js.map
